import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useGetAvailableTranslation } from '../hooks/global/Languages';
import zipcelx from 'zipcelx';
import { read as readXLSX, utils as xlsxUtils } from 'xlsx';

const TranslationTable = () => {
  const { i18n } = useTranslation();
  const resources = i18n.services.resourceStore.data;
  const languages = useGetAvailableTranslation();
  const baseLanguage = ["SL"];
  const [editTranslations, setEditTranslations] = useState({});
  const [show, setShow] = useState(false);


  const handleTranslationChange = (key, lang, value) => {
    const newTranslations = { ...editTranslations };
    if (!newTranslations[key]) {
      newTranslations[key] = {};
    }
    newTranslations[key][lang] = value;
    setEditTranslations(newTranslations);
  };

  const saveTranslations = (key) => {
    const keyTranslations = editTranslations[key];
    if (keyTranslations) {
      Object.entries(keyTranslations).forEach(([lang, value]) => {
        i18n.addResource(lang, 'translation', key, value);
      });
      alert(`Translations for "${key}" have been updated.`);
    }
  };

  const exportToExcel = () => {
    const headers = [{ value: 'Key', type: 'string' }];
    languages.forEach(lang => {
      headers.push({ value: lang.toUpperCase(), type: 'string' });
    });

    const data = Array.from(new Set(Object.keys(resources[baseLanguage[0]].translation))).map(key => {
      let row = [{ value: key, type: 'string' }];
      languages.forEach(lang => {
        const cellValue = editTranslations[key] && editTranslations[key][lang] !== undefined
          ? editTranslations[key][lang]
          : resources[lang]?.translation[key] || '';
        row.push({ value: cellValue, type: 'string' });
      });
      return row;
    });

    const config = {
      filename: 'translations',
      sheet: {
        data: [headers, ...data]
      }
    };

    zipcelx(config).then(() => {
      console.info('Excel file has been downloaded');
    }).catch(error => {
      console.error('Error exporting Excel:', error);
    });
  };

  const handleExcelToJSON = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = readXLSX(data, { type: 'array' });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const json = xlsxUtils.sheet_to_json(worksheet);
      createLocaleFiles(json);
    };
    reader.readAsArrayBuffer(file);
  };

  const createLocaleFiles = (data) => {
    const locales = {};

    // Initialize empty objects for each language
    languages.forEach(lang => {
      locales[lang] = {};
    });

    // Populate each locale object with translations
    data.forEach(row => {
      const key = row.Key;
      languages.forEach(lang => {
        locales[lang][key] = row[lang.toUpperCase()] || ''; // Use an empty string if no translation exists
      });
    });

    // Now you have a locales object where each property is a language code linked to its translations
    downloadLocaleFiles(locales);
  };

  const downloadLocaleFiles = (locales) => {
    Object.keys(locales).forEach(lang => {
      const filename = `${lang}.json`;
      const jsonStr = JSON.stringify(locales[lang], null, 2);
      const blob = new Blob([jsonStr], { type: 'application/json' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  };

  const loadTranslations = async (path = '../../locales/', name = 'backend') => {
    const fetchTranslations = async (lang) => {
      const lowerLang = lang.toLowerCase();
      const fetchPath = `${path}${lowerLang}/${name}.json`;
      try {
        const response = await fetch(fetchPath);
        if (!response.ok) {
          throw new Error(`Failed to fetch ${lowerLang} translations: ${response.statusText}`);
        }
        const translations = await response.json();
        return translations;
      } catch (error) {
        console.error(`Error fetching translations for language ${lowerLang}:`, error);
        return null;
      }
    };

    for (const lang of languages) {
      const translations = await fetchTranslations(lang);

      if (i18n.hasResourceBundle(lang, 'translation')) {
        i18n.removeResourceBundle(lang, 'translation');
      }

      i18n.addResourceBundle(lang, 'translation', translations, false, true);
    }
  };

  const loadAdmin = async () => {
   // await loadTranslations();
   //switchNamespace('translations');
    setShow(true);
  };

  const loadAPI = async () => {
    await loadTranslations('/admin/locales/', 'backend');
    //switchNamespace('backend');
    setShow(true);
  };

  const styles = {
    stickyHeader: {
      position: 'sticky',
      top: 0,
      backgroundColor: '#fff',
      zIndex: 1000,
      boxShadow: '0 2px 2px -1px rgba(0,0,0,0.4)'
    }
  };

  return (
    <div>
      <div className='row'>
        <div className='col-6'>
          <h3 className='m-1'>Translations</h3>
          <button className='btn m-1' onClick={loadAdmin} style={{ backgroundColor: '#f8bf2a' }}>LOAD ADMIN</button>
          <button className='btn m-1' onClick={loadAPI} style={{ backgroundColor: '#f8bf2a' }}>LOAD API</button>
        </div>
        <div className='col-6'>
          <h3 className='m-1'>Convert xls to json</h3>
          <input className='btn m-1' type="file" onChange={handleExcelToJSON} accept=".xlsx, .xls" />
        </div>
      </div>

      {show && (
        <div className='row'>
          <div className='col-12'>
            <button className='btn m-1' onClick={exportToExcel}>Export to Excel</button>

            <table className="table table-bordered">
              <thead>
                <tr style={styles.stickyHeader}>
                  <th>Key</th>
                  {languages.map(lang => (
                    <th key={lang}>{lang.toUpperCase()}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {Array.from(new Set(Object.keys(resources[baseLanguage[0]].translation))).map(key => (
                  <tr key={key}>
                    <td>{key}</td>
                    {languages.map(lang => (
                      <td key={lang} style={{ backgroundColor: resources[lang]?.translation[key] ? "#fff" : "rgb(253, 0, 0, 0.25)" }}>
                        <input
                          type="text"
                          value={editTranslations[key] && editTranslations[key][lang] !== undefined ? editTranslations[key][lang] : resources[lang]?.translation[key] || ''}
                          onChange={(e) => handleTranslationChange(key, lang, e.target.value)}
                          style={{ width: '100%', border: 'none', background: 'transparent' }}
                        />
                      </td>
                    ))}
                    <td>
                      <button onClick={() => saveTranslations(key)}>Save</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default TranslationTable;
